<template>
  <div class="imgText-content list-search-content">
    <div
      class="left-content"
      id="imgText-content"
      @scroll="onScroll"
      v-loading="loading"
      element-loading-text="Loading"
      element-loading-spinner="el-icon-loading"
    >
      <el-scrollbar style="height: 100%" ref="myScrollbar">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="add-box">
              <div class="model"></div>
              
              <div class="addNotice" @click="toAdd('notice')">
                <i class="el-icon-document-copy"></i>
                <p>公告</p>
              </div>
              <div class="addImgtext" @click="toAdd('article')">
                <i class="el-icon-picture-outline"></i>
                <p>图文</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" v-for="(item,index) in articleList" :key="index">
            <el-card class="box-card">
              <div class="image">
                <div class="sign" v-if="Number(item.articlestatus) === 1">已推</div>
                <div class="topTab" v-if="item.stick">置顶</div>
                <img :src="item.cover" @click="toDetail(item.id)" />
                <el-tooltip class="item" effect="dark" content="推送" placement="top-start">
                  <div class="send-icon" @click="send(item)">
                    <i class="el-icon-position"></i>
                  </div>
                </el-tooltip>
              </div>
              <div class="card-container">
                <div class="title">{{item.articletitle}}</div>
                <div class="card-bottom">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.stick===0?'置顶':'取消置顶'"
                    placement="top-start"
                  >
                    <i
                      :class="item.stick===0?'el-icon-upload2':'el-icon-upload2 sticked'"
                      @click="setTop(item.id,item.stick)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top-start" v-if="!item.remark">
                    <i class="el-icon-edit-outline" @click="edit(item.id)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                    <i class="el-icon-delete" @click="del(item.id)"></i>
                  </el-tooltip>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-scrollbar>
    </div>
    <aside class="aside-content">
      <el-scrollbar style="height: 100%" ref="myScrollbar">
        <el-form :model="reqData" ref="ruleForm" class="search-form" label-position="left">
          <div class="form-header">
            <span>筛选</span>
            <el-button @click="resetForm('ruleForm')" type="primary" size="mini" class="mini-btn">重置</el-button>
          </div>
          <el-form-item label="类型" prop="type">
            <el-radio-group v-model="reqData.type" @change="getData">
              <el-radio label="notice">公告</el-radio>
              <el-radio label="article">图文</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否置顶" prop="stick">
            <el-radio-group v-model="reqData.stick" @change="getData">
              <el-radio label="1">置顶</el-radio>
              <el-radio label="0">未置顶</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="文章标题" prop="articletitle">
            <el-input
              v-model="reqData.articletitle"
              placeholder="请输入..."
              @blur="getData"
              @keyup.enter.native="getData"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="时间" prop="time">
            <el-date-picker
              @change="getData"
              @blur="getData"
              v-model="reqData.time"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="分类" prop="articletypeids" class="typeItem">
            <i class="el-icon-plus plus-icon" @click="addTypedialog=true"></i>
            <el-checkbox-group v-model="reqData.articletypeids" @change="getData">
              <el-checkbox
                :label="item.id"
                class="typeLists"
                v-for="(item,index) in typeList"
                :key="index"
              >
                <img :src="item.icon" alt class="typeIcon" v-if="item.icon" />
                <span>{{item.name}}</span>
                <i class="el-icon-close del-icon" @click="delType(item.id)"></i>
                <span class="top-icon" @click="setTypeTop(item.id)">
                  <i class="el-icon-edit"></i> 置顶
                </span>
                <span class="typeNum">{{item.articlecount}}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </aside>
    <el-dialog :visible.sync="addTypedialog" width="20%">
      <el-form :model="addTypeData" label-width="80px" :rules="rules" ref="addTypeForm">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="addTypeData.name" autocomplete="off" size="small"></el-input>
        </el-form-item>
        <el-form-item label="分类图片" prop="icon">
          <el-upload
            class="avatar-uploader"
            :headers="{Authorization:token}"
            :on-success="handleAvatarSuccess"
            :action="$http.defaults.baseURL+'/cmy/cmy/SCommunitypic/uploadImg'"
            :show-file-list="false"
          >
            <img v-if="addTypeData.icon" :src="addTypeData.icon" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addTypedialog = false">取 消</el-button>
        <el-button type="primary" @click="addType">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api/news/publish.js";
export default {
  data() {
    return {
      loading: true,
      articleList: [],
      reqData: {
        page: 1,
        rows: 10,
        communityid: "",
        type: "", //article notice
        stick: "",
        articletitle: "",
        articletypeids: [],
        time: [],
        begincreatetimestr: "",
        endcreatetimestr: ""
      },
      totalPage: 0,
      activityKindName: "",
      typeList: [],
      addTypedialog: false,
      addTypeData: {
        name: "",
        icon: "",
        communityId: ""
      },
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }]
      }
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    token() {
      return this.$store.state.token;
    },
    sendList() {
      return this.$store.state.sendList;
    }
  },
  mounted() {
    this.getData();
    this.getTypeList();
    window.addEventListener("scroll", this.onScroll, true);
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.onScroll, true);
  },
  methods: {
    async getData(scroll) {
      if (scroll !== true) {
        this.loading = true;
        this.reqData.page = 1;
      }
      let data = JSON.parse(JSON.stringify(this.reqData));
      data.communityid = this.userInfo.communityId;
      data.begincreatetimestr =
        data.time && data.time.length > 0 ? data.time[0] : "";
      data.endcreatetimestr =
        data.time && data.time.length > 0 ? data.time[1] : "";
      delete data.time;
      data.articletypeids = data.articletypeids.join(",");
      let res = await this.$http.get(api.getArticles, { params: data });
      if (res && res.isSucceed) {
        this.loading = false;
        if (this.reqData.page === 1) {
          this.totalPage = Math.ceil(res.total / this.reqData.rows);
        }
        if (scroll === true) {
          this.articleList = [...this.articleList, ...res.rows];
          return;
        }
        this.articleList = res.rows;
      }
    },

    async getTypeList() {
      let data = {
        page: 1,
        rows: 100,
        communityId: this.userInfo.communityId
      };
      let res = await this.$http.get(api.typeList, { params: data });
      if (res && res.isSucceed) {
        this.typeList = res.rows;
      }
    },
    // 滚动事件
    onScroll() {
      let dom = document.querySelector(".imgText-content .el-scrollbar__wrap");
      const scrollDistance =
        dom.scrollHeight - dom.scrollTop - dom.clientHeight;
      if (scrollDistance <= 0) {
        if (this.reqData.page >= this.totalPage) return;
        this.reqData.page++;
        this.getData(true);
      }
    },
    handleAvatarSuccess(res, file) {
      this.addTypeData.icon = res.filepath;
    },
    // 添加分类
    async addType() {
      if ((this.addTypeData.name === "")) {
        this.$message.error("请输入要添加的分类");
        return false;
      }
      this.addTypeData.communityId = this.userInfo.communityId;
      let res = await this.$http.get(api.addType, { params: this.addTypeData });
      if (res && res.isSucceed) {
        this.$message({
          message: "添加成功",
          type: "success"
        });
        this.getTypeList();
        this.addTypedialog = false;
        this.$refs["addTypeForm"].resetFields();
      }
    },
    // 分类置顶
    async setTypeTop(id) {
      event.preventDefault();
      let res = await this.$http.post(
        api.setTypeTop,
        this.$qs.stringify({ id, communityId: this.userInfo.communityId })
      );
      if (res && res.isSucceed) {
        this.getTypeList();
      }
    },
    // 删除分类
    async delType(id) {
      event.preventDefault();
      let _this = this;
      _this
        .$confirm("删除后将无法恢复，请确认是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(async () => {
          let res = await this.$http.get(`${api.delType}?id=${id}`);
          if (res && res.isSucceed) {
            this.getTypeList();
          }
        });
    },
    // 文章置顶
    async setTop(id, stick) {
      let data = {
        id,
        stick: stick ? 0 : 1,
        communityId: this.userInfo.communityId
      };
      let res = await this.$http.post(api.setTop, this.$qs.stringify(data));
      if (res && res.isSucceed) {
        this.getData();
      }
    },
    edit(id) {
      this.$router.push({
        path: "/news/publish/imgTextAdd",
        query: {
          id
        }
      });
    },
    del(id) {
      let _this = this;
      _this
        .$confirm("删除后将无法恢复，请确认是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(async () => {
          let res = await this.$http.post(
            api.delArticle,
            this.$qs.stringify({ id })
          );
          if (res && res.isSucceed) {
            this.getData();
            _this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
    },
    // 推送
    send(item) {
      if (this.sendList.length >= 8) {
        this.$message.error("推送数据已超过上限");
        return;
      }
      for (let sendItem of this.sendList) {
        if (sendItem.id === item.id) {
          this.$message.error("无法重复推送,请重新选择");
          return;
        }
      }
      this.$store.commit("SET_SEND_LIST",  {name:'sendList',item});
    },
    toDetail(id) {
      this.$router.push({
        path: "/news/publish/imgTextDetail",
        query: {
          id
        }
      });
    },
    toAdd(type) {
      this.$router.push({
        path: "/news/publish/imgTextAdd",
        query: {
          type
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getData();
    }
  }
};
</script>
<style lang='less' scoped>
@import url("./index.less");
</style>
<style lang='less'>
@import url("../../../peopleOnline/volunteer/ele-index.less");

.imgText-content {
  .el-card__body {
    padding: 0px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
  .el-dialog {
    border-radius: 6px;
  }
}
</style>